// Beam selection tracking. Delegated on document so it survives Rebuy Smart Cart re-renders.
(function () {
  if (window.__beamTrackingInit) return;
  window.__beamTrackingInit = true;
  // selectionId set persists across the session so auto-restore on reload is not double counted.
  var seen = new Set(JSON.parse(sessionStorage.getItem('beam_seen_sel') || '[]'));
  var touched = false;
  // Track whether the user physically interacted with a Beam mount this pageview.
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest('beam-select-nonprofit, [class*="beam"]')) touched = true;
  }, true);
  document.addEventListener('beamnonprofitselect', function (e) {
    var d = e.detail || {};
    var selectionId = d.selectionId;
    if (!selectionId || seen.has(selectionId)) return; // dedupe restore and re-fires
    seen.add(selectionId);
    sessionStorage.setItem('beam_seen_sel', JSON.stringify(Array.from(seen)));
    (window.dataLayer = window.dataLayer || []).push({
      event: 'beam_nonprofit_select',
      beam_nonprofit_id: d.selectedNonprofitId,
      beam_selection_id: selectionId,
      beam_nonprofit_name: d.nonprofitName,
      beam_source: d.source,         // 'select-nonprofit' = cart; PDP value TBC
      beam_restored: !touched        // true => auto-restore, exclude in analysis
    });
  });
  document.addEventListener('beamnonprofitselectionremoved', function () {
    (window.dataLayer = window.dataLayer || []).push({ event: 'beam_selection_removed' });
  });
})();
